import React, { useEffect } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from 'sweetalert2';
import { apiErrorHtml } from "../../helpers/apiError";
// action
import { apiError } from "../../store/actions";

import { registerHotelAndHotelOwner } from "../../helpers/api.ts";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";

import { createSelector } from "reselect";

// import images
import logodark from "../../assets/images/logo-dark.png";

const Register = (props) => {
  document.title = "Register";

  const dispatch = useDispatch();
  const navigate = useNavigate();

const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      hotel_name: "",
      total_rooms: "",
      address: "",
      star_rating: "",
      ownerName: "",
      ownerEmail: "",
      password: "",
      mobile: "",
      type: "",
      gst_number: "",
      gst_percentage: "",
      hotel_image: null,
    },
    validationSchema: Yup.object({
      hotel_name: Yup.string().trim().min(3, "Hotel name must be at least 3 characters").required("Please Enter Hotel Name"),
      total_rooms: Yup.number()
        .required("Please Enter Total Rooms")
        .positive("Total rooms must be positive")
        .integer("Total rooms must be a whole number"),
      address: Yup.string().trim().min(5, "Address must be at least 5 characters").required("Please Enter Address"),
      star_rating: Yup.number()
        .min(1, "Rating must be between 1 and 5")
        .max(5, "Rating must be between 1 and 5")
        .required("Please Enter Star Rating"),
      ownerName: Yup.string().required("Please Enter Owner Name"),
      ownerEmail: Yup.string()
        .email("Please enter a valid email")
        .required("Please Enter Owner Email"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .required("Please Enter Password"),
      mobile: Yup.string()
        .matches(/^[0-9]+$/, "Must be only digits")
        .length(10, "Mobile number must be exactly 10 digits")
        .required("Please Enter Mobile Number"),
      type: Yup.string().required("Please Select Hotel Type"),
      gst_number: Yup.string()
      .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST Number")
      .length(15, "GST number must be exactly 15 characters"),
      // .required("Please Enter GST Number"),
    
      gst_percentage: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits"),
      // .required("Please Enter GST Percentage"),
      hotel_image: Yup.mixed()
        .nullable()
        .test("fileSize", "File size must be less than 5MB", (value) => {
          return !value || (value && value.size <= 5 * 1024 * 1024);
        })
        .test("fileType", "Only image files are allowed (jpeg, jpg, png, gif)", (value) => {
          return !value || (value && ["image/jpeg", "image/jpg", "image/png", "image/gif"].includes(value.type));
        }),
    }),
    onSubmit: async (values) => {
      try {
        // Create FormData for file upload
        const formData = new FormData();
        
        // Add all form fields to FormData
        Object.keys(values).forEach(key => {
          if (values[key] !== null && values[key] !== undefined) {
            formData.append(key, values[key]);
          }
        });

        const response = await registerHotelAndHotelOwner(formData);
        if (response.success) {
          Swal.fire({
            title: 'Success!',
            text: 'Hotel registered successfully',
            icon: 'success',
            confirmButtonText: 'Ok'
          }).then(() => {
            navigate("/login", { replace: true });
          });
        }
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          html: apiErrorHtml(error, 'Registration failed'),
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    },
});

  const registerpage = createSelector(
    (state) => state.account,
    (state) => ({
      user: state.user,
      registrationError: state.registrationError,
    })
  );
  // Inside your component
  const { user, registrationError } = useSelector(registerpage);

  // handleValidSubmit
  // const handleValidSubmit = values => {
  //   dispatch(registerUser(values));
  // };
  

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  return (
    <div className="bg-pattern">
      <div className="bg-overlay"></div>
      <div className="account-pages pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={6}>
              <Card className="mt-5">
                <CardBody className="p-4">
                  <div className="text-center">
                    <Link to="/" className="">
                      <img
                        src={logodark}
                        alt=""
                        height="100"
                        className="auth-logo logo-dark mx-auto"
                      />
                      <img
                        src={logodark}
                        alt=""
                        height="100"
                        className="auth-logo logo-light mx-auto"
                      />
                    </Link>
                  </div>

                  <h4 className="font-size-18 text-muted text-center mt-2">
                    Free Register
                  </h4>
                  {/* <p className="text-muted text-center mb-4">
                    Get your free Upzet account now.
                  </p> */}
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {user && user ? (
                      <Alert color="success">Register User Successfully</Alert>
                    ) : null}

                    {registrationError && registrationError ? (
                      <Alert color="danger">
                        <div>{registrationError}</div>
                      </Alert>
                    ) : null}

                    <Row className="g-2">
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Hotel Name</Label>
                          <Input
                            name="hotel_name"
                            type="text"
                            placeholder="Enter hotel name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.hotel_name || ""}
                            invalid={
                              validation.touched.hotel_name &&
                              validation.errors.hotel_name
                            }
                          />
                          {validation.touched.hotel_name &&
                            validation.errors.hotel_name && (
                              <FormFeedback type="invalid">
                                {validation.errors.hotel_name}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Total Rooms</Label>
                          <Input
                            name="total_rooms"
                            type="number"
                            placeholder="Enter total rooms"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.total_rooms || ""}
                            invalid={
                              validation.touched.total_rooms &&
                              validation.errors.total_rooms
                            }
                          />
                          {validation.touched.total_rooms &&
                            validation.errors.total_rooms && (
                              <FormFeedback type="invalid">
                                {validation.errors.total_rooms}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Rooms Type</Label>
                          <Input
                            name="type"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.type || ""}
                            invalid={
                              validation.touched.type && validation.errors.type
                            }
                          >
                            <option value="">Select Type</option>
                            <option value="Both">Both</option>
                            <option value="AC">AC</option>    
                            <option value="Non-AC">Non-AC</option>
                            {/* <option value="BOUTIQUE">Boutique</option> */}
                          </Input>
                          {validation.touched.type &&
                            validation.errors.type && (
                              <FormFeedback type="invalid">
                                {validation.errors.type}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Star Rating</Label>
                          <Input
                            name="star_rating"
                            type="select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.star_rating || ""}
                            invalid={
                              validation.touched.star_rating &&
                              validation.errors.star_rating
                            }
                          >
                            <option value="">Select Rating</option>
                            {[1, 2, 3, 4, 5].map((num) => (
                              <option key={num} value={num}>
                                {num} Star{num > 1 ? "s" : ""}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.star_rating &&
                            validation.errors.star_rating && (
                              <FormFeedback type="invalid">
                                {validation.errors.star_rating}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
  <div className="mb-4">
    <Label className="form-label">GST Number</Label>
    <Input
      name="gst_number"
      type="text"
      placeholder="Enter GST number"
      onChange={validation.handleChange}
      onBlur={validation.handleBlur}
      value={validation.values.gst_number || ""}
      invalid={
        validation.touched.gst_number &&
        validation.errors.gst_number
      }
    />
    {validation.touched.gst_number &&
      validation.errors.gst_number && (
        <FormFeedback type="invalid">
          {validation.errors.gst_number}
        </FormFeedback>
      )}
  </div>
</Col>
<Col xs={12} md={6}>
  <div className="mb-4">
    <Label className="form-label">GST Percentage</Label>
    <Input
      name="gst_percentage"
      type="text"
      placeholder="Enter GST percentage"
      onChange={validation.handleChange}
      onBlur={validation.handleBlur}
      value={validation.values.gst_percentage || ""}
      invalid={
        validation.touched.gst_percentage &&
        validation.errors.gst_percentage
      }
    />
    {validation.touched.gst_percentage &&
      validation.errors.gst_percentage && (
        <FormFeedback type="invalid">
          {validation.errors.gst_percentage}
        </FormFeedback>
      )}
  </div>
</Col>

                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Owner Name</Label>
                          <Input
                            name="ownerName"
                            type="text"
                            placeholder="Enter owner name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.ownerName || ""}
                            invalid={
                              validation.touched.ownerName &&
                              validation.errors.ownerName
                            }
                          />
                          {validation.touched.ownerName &&
                            validation.errors.ownerName && (
                              <FormFeedback type="invalid">
                                {validation.errors.ownerName}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Owner Email</Label>
                          <Input
                            name="ownerEmail"
                            type="email"
                            placeholder="Enter owner email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.ownerEmail || ""}
                            invalid={
                              validation.touched.ownerEmail &&
                              validation.errors.ownerEmail
                            }
                          />
                          {validation.touched.ownerEmail &&
                            validation.errors.ownerEmail && (
                              <FormFeedback type="invalid">
                                {validation.errors.ownerEmail}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            type="password"
                            placeholder="Enter password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                            }
                          />
                          {validation.touched.password &&
                            validation.errors.password && (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="mb-4">
                          <Label className="form-label">Mobile Number</Label>
                          <Input
                            name="mobile"
                            type="text"
                            placeholder="Enter mobile number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.mobile || ""}
                            invalid={
                              validation.touched.mobile &&
                              validation.errors.mobile
                            }
                          />
                          {validation.touched.mobile &&
                            validation.errors.mobile && (
                              <FormFeedback type="invalid">
                                {validation.errors.mobile}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={12}>
                        <div className="mb-4">
                          <Label className="form-label">Address</Label>
                          <Input
                            name="address"
                            type="textarea"
                            placeholder="Enter hotel address"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ""}
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                            }
                          />
                          {validation.touched.address &&
                            validation.errors.address && (
                              <FormFeedback type="invalid">
                                {validation.errors.address}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col xs={12} md={12}>
                        <div className="mb-4">
                          <Label className="form-label">Hotel Logo</Label>
                          <Input
                            name="hotel_image"
                            type="file"
                            accept="image/jpeg,image/jpg,image/png,image/gif"
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              validation.setFieldValue("hotel_image", file);
                            }}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.hotel_image &&
                              validation.errors.hotel_image
                            }
                          />
                          {validation.touched.hotel_image &&
                            validation.errors.hotel_image && (
                              <FormFeedback type="invalid">
                                {validation.errors.hotel_image}
                              </FormFeedback>
                            )}
                          {/* <small className="text-muted">
                            Upload hotel image (Max 5MB)
                          </small> */}
                        </div>

                        <div className="d-grid mt-4">
                          <button
                            className="btn btn-primary waves-effect waves-light w-100 w-md-auto"
                            type="submit"
                          >
                            Register
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="text-white-50">
                  Already have an account ?
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    Login{" "}
                  </Link>{" "}
                </p>
                <p className="text-white-50">
                  © {new Date().getFullYear()} Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Govindani Infotech Pvt. Ltd.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Register;


